<script setup lang="ts">
import type { StickerFill } from '../SfgSticker.vue'

/**
 * SfgHeart — classic two-lobe heart silhouette. Square aspect.
 */

const props = withDefaults(defineProps<{
  border?: StickerFill
  fill?: StickerFill
  size?: number | string
  tilt?: number
}>(), {
  border: 'ink',
  fill: 'red',
  size: 60,
  tilt: -4,
})

const sizeCss = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size))
const fillVar = computed(() => `var(--color-brand-${props.fill})`)
const strokeVar = computed(() => `var(--color-brand-${props.border})`)
</script>

<template>
  <svg
    aria-hidden="true"
    :style="{
      width: sizeCss,
      height: sizeCss,
      transform: `rotate(${tilt}deg)`,
      filter: 'drop-shadow(0 3px 0 rgba(0, 0, 0, 0.6))',
    }"
    viewBox="0 0 100 100"
  >
    <!--
      Two-lobe heart, classic silhouette:
      - Pointed bottom tip at (50, 86)
      - Distinct left and right lobes with separate Bezier peaks
      - V cusp at the top center (50, 24)
      - Wide and full-bodied so the shape reads as a heart at any
        size, not just a generic blob.
    -->
    <path
      d="M 50 86
         C 25 68  4 50  4 28
         C 4 14   16 4  28 4
         C 38 4   46 12 50 24
         C 54 12  62 4  72 4
         C 84 4   96 14 96 28
         C 96 50  75 68 50 86 Z"
      :fill="fillVar"
      :stroke="strokeVar"
      stroke-width="4"
      stroke-linejoin="round"
    />
  </svg>
</template>
